<template>
  <div>
    <pulse-header></pulse-header>
    <b-container fluid class="main-content">
      <Overlay :isDisplayed="showOverlay" @overlay-clicked="turnOffSpotlight" />
        <div class="main-layout">
          <div class="main-layout_column">
            <DataEngineCard
              title="CRM SYSTEM"
              location='DataEngineAddCRM'
              mappable='CRM'
              :contentData='contentDataCRM'
              type='source' />
          </div>
          <div class="main-layout_column">
            <DataEngineStitch class="mar-bottom--xl"/>
          </div>
          <div class="main-layout_column">
            <DataEngineCard
              title="ADOBE ANALYTICS"
              location='DataEngineAddAnalytics'
              mappable='analytics'
              :contentData='contentDataAnalytics'
              type='output' />
          </div>
        </div>
    </b-container>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import DataEngineCard from '@/components/DataEngineCard.vue'
import DataEngineStitch from '@/components/DataEngineStitch.vue'
import Overlay from '@/components/Overlay'
import PulseHeader from '@/components/Header.vue'
import CrmConnections from '@/api/CRM/CrmConnections.js'
import AnalyticsReport from '@/api/Analytics/AnalyticsReport.js'

export default {
  components: {
    DataEngineCard,
    DataEngineStitch,
    Overlay,
    PulseHeader
  },
  data () {
    return {
      CRMData: {},
      AnalyticsData: {}
    }
  },
  computed: {
    ...mapState(
      'ux', {
        showOverlay: state => state.overlayIsDisplayed }),
    ...mapState(
      'data', {
        contentDataCRM: state => state.CRMData,
        contentDataAnalytics: state => state.AnalyticsData,
        contentDataAttrbutes: state => state.AttrbutesData
      })
  },
  created () {
    CrmConnections.getCrm()
      .then(response => {
        this.$store.commit('data/updateCrm', response)
      })
    AnalyticsReport.getAAConnection()
      .then(response => {
        this.$store.commit('data/updateAA', response)
      })
  },
  mounted () {
    this.$store.commit('updateLeaderLines')
  },
  methods: {
    ...mapActions({ turnOffSpotlight: 'ux/turnOffSpotlight' })
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
